import { Component } from '@angular/core';
import { ButtonDirective } from '@shared/components/input/button/button.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { UserService } from '@app/core/services/user.service';

@Component({
  selector: 'app-auth-failed',
  imports: [
    ButtonDirective,
    TranslatePipe
  ],
  templateUrl: './auth-failed.component.html',
  styleUrl: './auth-failed.component.css'
})
export class AuthFailedComponent {
  constructor(
    private readonly userService: UserService,
  ) {}

  public logout(): void {
    this.userService.logout();
  }

  public login(): void {
    this.userService.login();
  }

}
